import { SITE_IN_A_BOX_SITE_DETAILS_KEYS } from "@repo/ui/site-in-a-box";
const toSiteInABoxRow = (value) => {
    if (value == null || typeof value !== "object") {
        return null;
    }
    return value;
};
export function siteInABoxIdsMatch(a, b) {
    if (a === undefined || b === undefined) {
        return false;
    }
    return String(a) === String(b);
}
/** Merge API save payload into an existing list/detail row without dropping site-detail fields. */
export function mergeSiteInABoxItemUpdate(existing, saved) {
    const merged = { ...existing, ...saved };
    for (const key of SITE_IN_A_BOX_SITE_DETAILS_KEYS) {
        if (saved[key] === undefined && existing[key] !== undefined) {
            merged[key] = existing[key];
        }
    }
    return merged;
}
export const mergeSiteInABoxItemsById = (items, targetId, patch) => items.map((item) => {
    const row = toSiteInABoxRow(item);
    if (row && siteInABoxIdsMatch(row.id, targetId)) {
        return mergeSiteInABoxItemUpdate(row, patch);
    }
    return item;
});
export const mergeSiteInABoxSelectedItemById = (selectedItem, targetId, patch) => {
    const row = toSiteInABoxRow(selectedItem);
    if (row && siteInABoxIdsMatch(row.id, targetId)) {
        return mergeSiteInABoxItemUpdate(row, patch);
    }
    return selectedItem;
};
export const mergeFetchedSiteInABoxIntoItems = (items, fetchedItem) => {
    const fetched = toSiteInABoxRow(fetchedItem);
    if (fetched?.id == null) {
        return items;
    }
    return mergeSiteInABoxItemsById(items, fetched.id, fetched);
};
